export const RootPaths = {
  HOME: "/home",
  WELCOME: "/welcome",
  LINK: "/link",
  APP_V2: "/v2",
  APP_V2_HOME: "/home-v2",
  NOT_FOUND: "/not-found",
  ERROR: "/error",
  AUTH_REDIRECT: "/auth/redirect",
};

/**
 * Split these up and move these paths into the projects that manage these paths.
 */
export const DeprecatedGlobalAppV1Paths = {
  MY_SHIFTS: `${RootPaths.HOME}/myShifts`,
  OPEN_SHIFTS: `${RootPaths.HOME}/openShifts`,
  RATINGS_BADGES: `${RootPaths.HOME}/ratings/badges`,
  CHAT: `${RootPaths.HOME}/account/chat/:facilityId`,
  ADDRESS: `${RootPaths.HOME}/account/address`,
  PROFILE_CONTRACT: `${RootPaths.HOME}/account/profile/contract`,
  MY_SHIFT_DETAIL: `${RootPaths.HOME}/myShifts/:shiftId`,
  UNVERIFIED_SHIFTS: `${RootPaths.HOME}/myShifts/unverifiedShifts`,
  SUCCESS_ONBOARDING: `${RootPaths.HOME}/alreadyOnboarded`,
  PAYMENT_SERVICE_ONBOARDING: `${RootPaths.HOME}/onboardingPayments`,
  UPDATED_CONTRACTOR_AGREEMENT: `${RootPaths.HOME}/updatedContractorAgreement`,
  FACILITY_DETAIL: `${RootPaths.HOME}/facility/:facilityId`,
  NEED_HELP: `${RootPaths.HOME}/account/needhelp`,
  HELP_DETAILS: `${RootPaths.HOME}/account/needhelp/details`,
  UPDATE_PROFILE: `${RootPaths.HOME}/updateProfile`,
  LICENSE_MANAGER: `${RootPaths.HOME}/account/licenses`,
  LICENSE_MANAGER_ADD: `${RootPaths.HOME}/account/licenses/add`,
  LICENSE_DETAILS: `${RootPaths.HOME}/account/licenses/:licenseId/details`,
  ADD_LICENSE: `${RootPaths.HOME}/account/licenses/add`,
  LICENSE_RECIPROCITY: `${RootPaths.HOME}/account/license-reciprocity`,
  COLLEAGUE_LIST: `${RootPaths.HOME}/colleagueList`,
  RATE_NEGOTIATIONS: `${RootPaths.HOME}/rate-negotiations`,
  FRIENDS_LIST: `${RootPaths.HOME}/account/friends`,
  SETUP_STRIPE: `${RootPaths.HOME}/stripeSetUp`,
  NOTIFICATION_CENTER: `${RootPaths.HOME}/notification-center`,
  CAREER_AGENT: `${RootPaths.HOME}/careerAgent`,
  WORKPLACE_REFERRALS: `${RootPaths.HOME}/account/workplace-referrals`,
  RATE_NEGOTIATION_TOOL: `${RootPaths.HOME}/rate-negotiation-tool/:shiftId`,
  SHIFT_FEEDBACK_RESOLVER: `${RootPaths.HOME}/shift-feedback-resolver`,
  CLIPBOARD_GUIDES_CHAT: `${RootPaths.HOME}/account/clipboard-guides-chat/:workplaceId`,
  WORKPLACE_GROUP_CHAT: `${RootPaths.HOME}/account/workplace-group-chat/:workplaceId`,
};
